module.exports = __webpack_public_path__ + "img/g.f1495a61.svg";